// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".provider-popup-wrapper[data-v-cadaacda]{color:#738583;display:flex;flex-direction:column;margin-bottom:32px}.provider-name[data-v-cadaacda]{color:var(--primary-color);font-weight:700;margin-bottom:16px;text-decoration:none;font-size:14px}.provider-description[data-v-cadaacda]{font-size:14px;font-weight:700;margin-bottom:4px}.online-button[data-v-cadaacda]{margin:16px 0 8px 0;color:#fff}", ""]);
// Exports
module.exports = exports;
